import { render, staticRenderFns } from "./IcoCallout.vue?vue&type=template&id=6ce478e6"
import script from "./IcoCallout.vue?vue&type=script&lang=js"
export * from "./IcoCallout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports